import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { CloudDownload, ErrorOutline, Print, Sync } from "@mui/icons-material";
import { Box, Button, Card, FormLabel, Grid, Icon, MenuItem, TextField, styled } from "@mui/material";
import { Loader } from "app/components";
import { getAllProjectLocationListForReports } from "app/redux/actions/ProjectLocationActions";
import { getGoodsReceiptReport } from "app/redux/actions/ReportsAction";
import { AppConstants } from "app/utils/AppConstants";
import { ServiceUrl } from 'app/utils/Constants';
import { SnackBarProperty } from "app/utils/SnackBarProperty";
import { checkValidation, currencyFormat, formatNumberWithCommasAndDecimals, getTwoDigitDecimal } from "app/utils/utils";
import { SimpleCard } from "components";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import moment from "moment";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";


const styles = {
  tableCell: {
    textAlign: "center"
  },
  subHeader: {
    textAlign: "center",
    fontWeight: 700
  }

}
const DecoratedTextField = styled(TextValidator)(() => ({
  width: "100%",
  marginBottom: "16px",
}));




export const GoodsReceiptReport = () => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isDownloading, setIsDownloading] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const [projectDetails, setProjectDetails] = useState()
  const { reportsProjectLocationList } = useSelector((state) => state.projectLocation);
  const [totalAmount, setTotalAmount] = useState()
  const [originalTableData, setOriginalTableData] = useState()
  const [filteredTableData, setFilteredTableData] = useState([])
  const [state, setState] = useState({
    project_location_id: '',
  })


  useEffect(() => {
    dispatch(getAllProjectLocationListForReports(showLoader, hideLoader, showToast))
  }, []);
  const showLoader = () => {
    setLoading(true)
  }
  const showToast = (msg) => {
    const key = enqueueSnackbar(msg ?? AppConstants.somethingWentWrong, { variant: 'error' });
    SnackBarProperty.error(key, closeSnackbar);
  }

  const hideLoader = () => {
    setLoading(false)
  }
  const handleChange = (event, source) => {

    if (event.target.name === "project_location_id") {
      setOriginalTableData([])
      const filteredArray = reportsProjectLocationList.filter(project => {
        return project.project_location_id === event.target.value
      });
      state.project_name = filteredArray[0].project_name
      state.project_location_id = filteredArray[0].project_location_id
      state.project_id = filteredArray[0].project_id

      setState({ ...state, [event.target.name]: event.target.value });

    } else {
      setState({ ...state, [event.target.name]: event.target.value });
    }
  }


  const handleFormSubmit = () => {
    setLoading(true)
    // setOriginalTableData([])
    getGoodsReceiptReport({ project_location_id: state?.project_location_id })
      .then((res) => {
        setLoading(false)

        if (res?.status < 300) {
          if (res?.data?.obj && res?.data?.obj?.item && res?.data?.obj?.item?.good_receipt_list?.length > 0) {
            const tableDataList = res?.data?.obj?.item?.good_receipt_list?.map(item => {

              item?.item_list?.forEach(elem => {
                elem.receipt_no = item?.good_receipt_no
              })
              return item?.item_list
            }).flat()
            const TotalAmount = tableDataList.reduce((sum, item) => {
              return sum + item.amount;
            }, 0);
            setTotalAmount(getTwoDigitDecimal(TotalAmount))
            setOriginalTableData(tableDataList)
            setProjectDetails({
              company: res?.data?.obj?.agency_name,
              project_id: res?.data?.obj?.item?.project_id,
              project_name: res?.data?.obj?.item?.projectname,
              contractNo: res?.data?.obj?.item?.tender_id,
              // workPlanNo:res?.data?.obj?.item?.workorder_no,
              header: res?.data?.obj?.header_logo,
              footer: res?.data?.obj?.footer_logo

            })
          }
          else {
            const key = enqueueSnackbar(res?.data?.message, { variant: 'info' });
            SnackBarProperty.info(key, closeSnackbar);

            setProjectDetails({})
            setOriginalTableData([])
          }


        }
        else {
          const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);

        }
      }).catch(error => {
        setLoading(false)
        const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      })


    function mergeByConstructionType(data) {
      console.log("data", data)
      const result = data.reduce((acc, curr) => {
        console.log("current", curr)
        const constructionType = curr.construcion_type;
        const totalAmount = curr.item_list.reduce((sum, item) => sum + item.amount, 0);

        // Create a new object with construction_type and total
        acc.push({ description: `Total for ${constructionType} (Nu)`, total: totalAmount });
        return acc;
      }, []);

      return result;
    }


  }

  const handleReportDownload = (isPrint) => {
    if (isPrint) {
      setIsPrinting(true)
      setIsDownloading(false)
    }
    else {
      setIsPrinting(false)
      setIsDownloading(true)
    }
    const doc = new jsPDF();


      const headerHeight = checkValidation(projectDetails?.header) ? 35 : 15
      const textX = 15;
      const textY = headerHeight
      doc.setFont('helvetica', 'bold'); // Set font to bold
      doc.setFontSize(12); // Set font size

      doc.text("GOODS RECEIPT", (doc.internal.pageSize.getWidth() / 2) - ((doc.getStringUnitWidth("GOODS RECEIPT") * doc.internal.getFontSize() / doc.internal.scaleFactor) / 2), textY);
      // Add the text content below the header image
      doc.setFont('helvetica', 'bold'); // Set font to bold
      doc.setFontSize(8); // Set font size
      doc.text("Project ID:", textX, textY + 10);
      const firstTextWidth = doc.getStringUnitWidth("Project ID:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      doc.setFont('helvetica', 'normal');
      doc.text(projectDetails?.project_id, textX + firstTextWidth + 5, textY + 10);

      doc.setFont('helvetica', 'bold'); // Set font to bold
      doc.setFontSize(8); // Set font size
      doc.text("Project Name:", textX, textY + 15);
      const secondTextWidth = doc.getStringUnitWidth("Project Name:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      doc.setFont('helvetica', 'normal');
      doc.text(projectDetails?.project_name, textX + secondTextWidth + 5, textY + 15);

      doc.setFont('helvetica', 'bold');
      doc.text("Client:", textX, textY + 20);
      const thirdTextWidth = doc.getStringUnitWidth("Client:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      doc.setFont('helvetica', 'normal');
      doc.text(projectDetails?.company, textX + thirdTextWidth + 5, textY + 20);
      doc.setFont('helvetica', 'bold');
      doc.text("Contract No.:", textX, textY + 25);
      const forthTextWidth = doc.getStringUnitWidth("Contract No.:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      doc.setFont('helvetica', 'normal');
      doc.text(`${projectDetails?.contractNo}`, textX + forthTextWidth + 5, textY + 25);
      doc.setFont('helvetica', 'normal');


      const headerSectionHeight = headerHeight + 40; // Adjust the value as needed

      // Calculate the starting Y-coordinate for the table
      const tableStartY = headerSectionHeight + 5;
      doc.setFont('helvetica', 'normal'); // Reset font to normal
      function transformData(data) {
        const newArr = data.map((row) => {
          return [
            { content: moment(row?.good_receipt_date).format("DD/MM/YYYY"), styles: { fontSize: 8 } },
            { content: row?.receipt_no, styles: { fontSize: 8 } },
            { content: row?.challan_no, styles: { fontSize: 8 } },
            { content: row?.item_code, styles: { fontSize: 8 } },
            { content: row?.item_description, styles: { fontSize: 8 } },
            { content: row?.original_quantity?.toString(), styles: { fontSize: 8 } },
            { content: row?.unit_name, styles: { fontSize: 8 } },
            { content: formatNumberWithCommasAndDecimals(row?.rate), styles: { fontSize: 8 } },
            { content: formatNumberWithCommasAndDecimals(row?.amount), styles: { fontSize: 8, valign: "middle", halign: "right" } }
          ]
        });
        return newArr;
      }

      const transformedData = transformData(filteredTableData);
      transformedData?.push([
        { content: "Total Amount", colSpan: 8, styles: { fontSize: 8, fontStyle: "bold", valign: "middle", halign: "right" } }, { content: `${formatNumberWithCommasAndDecimals(totalAmount)}`, styles: { fontSize: 8, fontStyle: "bold", valign: "middle", halign: "right" } }])

      doc.autoTable({
         margin: { 
          top: 30,      // push below header
          bottom: 30    // leave space above footer
        },
        startY: tableStartY,
        head: [[
          { content: "GR Date", colSpan: 1, styles: { valign: "middle", halign: "left", cellPadding: 2, fontSize: 8 } },
          { content: "Good Receipt No.", colSpan: 1, styles: { valign: "middle", halign: "left", cellPadding: 2, fontSize: 8 } },
          { content: "Challan No.", colSpan: 1, styles: { valign: "middle", halign: "left", cellPadding: 2, fontSize: 8 } },
          { content: "Item Code", colSpan: 1, styles: { valign: "middle", halign: "left", cellPadding: 2, fontSize: 8 } },
          { content: "Description", colSpan: 1, styles: { valign: "middle", halign: "left", cellPadding: 2, fontSize: 8 } },
          { content: "Quantity", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Unit", colSpan: 1, styles: { valign: "middle", halign: "left", cellPadding: 2, fontSize: 8 } },
          { content: "Rate (Nu)", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Amount (Nu)", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } }
        ]],
        body: transformedData, // Use the transformed data here
        theme: "grid",
        styles: {
          fillColor: [255, 255, 255], // Remove background color from the table
          lineColor: [0, 0, 0], // Set border color for main table
          lineWidth: 0.1, // Set border width for main table
          textColor: [0, 0, 0], // Set text color to black
          cellPadding: 2, // Add padding to cells
        },
        columnStyles: {
          3: { cellWidth: 30 },
          6: { halign: "right" },
          7: { halign: "right" },
          //   3: { halign: "right" }, // "UNIT" column width
        },
      });
      doc.setFont('helvetica', 'bold'); // Set font to bold
      doc.setFontSize(8); // Set font size
      // doc.text(`Total (Nu):  ${formatNumberWithCommasAndDecimals(totalAmount)}`, doc.internal.pageSize.getWidth() - 70, doc.autoTable.previous.finalY + 10);
      doc.text("Prepared by:", 15, doc.autoTable.previous.finalY + 15);
      //const footerFirstTextWidth = doc.getStringUnitWidth("Prepared By:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      doc.text("Checked by:", doc.internal.pageSize.getWidth() - 90, doc.autoTable.previous.finalY + 15);
      doc.text("Recommended by:", 15, doc.autoTable.previous.finalY + 25);
      // Function to add footer on each page
      const totalNumPages = doc.internal.getNumberOfPages();

      // Loop through each page to add the footer with page numbers
      for (let i = 1; i <= totalNumPages; i++) {
  
        const pdfWidth = doc.internal.pageSize.getWidth() - 30;
  
        // Header
        const headerHeight = 20;
        const headerX = 15;
        const headerY = 0; // at the very top
        if (checkValidation(projectDetails?.header)) {
          doc.addImage(
            `${ServiceUrl?.showImageUrl}${projectDetails?.header}`,
            headerX,
            headerY,
            pdfWidth,
            headerHeight
          );
        }
  
        //Footer
        const footerX = 15; // Starting X position for the footer
        const footerY = doc.internal.pageSize.getHeight() - 20; // 10 units from the bottom
        const footerHeight = 20;
        doc.setPage(i);
        if (checkValidation(projectDetails?.footer)) {
          doc.addImage(`${ServiceUrl?.showImageUrl}${projectDetails?.footer}`, footerX, footerY, pdfWidth, footerHeight)
        }
      }
      const scaleFactor = 1.0; // Adjust this value as needed
      const pdfBlob = doc.output('blob', { scale: scaleFactor });

      // Create a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Open a new window with the PDF URL


      // After the new window is opened, you can close the URL object

      if (isPrint) {
        const newWindow = window.open(pdfUrl, '_blank');
        URL.revokeObjectURL(pdfUrl);
        if (newWindow) {
          newWindow.onload = () => {
            setIsPrinting(false)
            setIsDownloading(false)
            // Wait for the window to load and then trigger the print dialog
            newWindow.print();
          };
        }
      }

      setIsPrinting(false)
      setIsDownloading(false)

      isPrint === false && doc.save('Contract_Goods_Receipt_Report.pdf');

  };


  const handleFilter = () => {
    console.log("originalData:", originalTableData)
    const filteredReceipt = originalTableData.filter(data => {
      const receiptDate = moment(data?.good_receipt_date).format("YYYY-MM-DD");

      return moment(receiptDate).isBetween(state?.from_date, state?.to_date, null, '[]'); // '[]' includes the boundaries
    });
    console.log("filtered receipt:", filteredReceipt)
    if (filteredReceipt?.length > 0) {
      console.log("filtered receipt:", filteredReceipt)
      setFilteredTableData(filteredReceipt)
      // const key = enqueueSnackbar("Applied Successful", { variant: 'success' });
      // SnackBarProperty.success(key, closeSnackbar);
    }
    else {
      // setIsNoFilterData(true)
      setFilteredTableData([])
      const key = enqueueSnackbar("No receipt found in this date range", { variant: 'info' });
      SnackBarProperty.info(key, closeSnackbar);
    }
  }
  const handleRefresh = () => {
    setState({ ...state, from_date: null, to_date: null })
    setFilteredTableData(originalTableData)
  }

  useEffect(() => {
    setFilteredTableData(originalTableData)
  }, [originalTableData])

  useEffect(() => {
    if (filteredTableData?.length > 0) {
      const grand_total = filteredTableData.reduce((sum, item) => sum + item?.amount, 0)
      setTotalAmount(getTwoDigitDecimal(grand_total))
    }
  }, [filteredTableData])





  return (
    <>
      <div style={{ height: 'auto', width: "100%", padding: '30px', display: "flex", flexDirection: "column", gap: "20px" }}>

        <Grid container>

          <Grid item xs={12}>
            <Button
              size="small"
              sx={{ width: "100px" }}
              variant="contained"
              color="error"
              onClick={() => { window.history.back() }}
            >
              <Icon color="primary" fontSize="small">
                skip_previous
              </Icon>
              Back
            </Button>
          </Grid>
        </Grid>
        <SimpleCard>
          <ValidatorForm onSubmit={handleFormSubmit}>
            <Grid container spacing={3} style={{ marginTop: '-45px', marginBottom: '15px' }} >
              <Grid item xs={12}><b className="font20 extraBold" style={{ color: "#ebad4e" }}>Goods Receipt</b></Grid>
            </Grid>
            <Grid container spacing={3} >
              {/* <Grid item xs={12}>
                <RadioGroup
                  row
                  name="reportType"
                  value={reportType}
                  onChange={(e) => { setReportType(e.target.value); setOriginalTableData([]) }}
                >&nbsp;&nbsp;
                  <FormControlLabel
                    label="Project BoQ Report"
                    value="report"
                    control={<Radio size="small" color="secondary" />}
                    sx={{ mr: 3, height: 20 }}
                  />
                  <FormControlLabel
                    label="Project BoQ Report Summary"
                    value="summaryReport"
                    control={<Radio size="small" color="secondary" />}
                    sx={{ height: 20 }}
                  />
                </RadioGroup>

              </Grid> */}
              <Grid item sm={4} xs={12}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  label="Project ID"
                  id="project_location_id"
                  variant="outlined"
                  name="project_location_id"
                  value={state?.project_location_id}
                  onChange={handleChange}
                  validators={["required"]}
                  errorMessages={["Project ID is required"]}
                >
                  {reportsProjectLocationList?.map((item) => (
                    <MenuItem value={item?.project_location_id} key={item?.project_id}>
                      {item?.project_id}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item sm={4} xs={12}>


                <Button size="medium" color="success" variant="contained" type="submit" style={{ marginLeft: 4 }} >View</Button>

              </Grid>

            </Grid>

          </ValidatorForm>
        </SimpleCard>
        {originalTableData && originalTableData?.length > 0 && <Grid container>
          <Grid xs={12} md={6}>
            {/* {checkValidation(projectDetails?.header) === false && <FormLabel sx={{ color: "#ff9800" }} color="warning">! Please upload header and footer for download/print</FormLabel>} */}
          </Grid>
          <Grid item xs={12} md={6}>
            <Box component="span" display="flex" justifyContent="flex-end">
              <Button
                size="small"
                sx={{ width: "130px", marginLeft: 4 }}
                variant="contained"
                // disabled={projectDetails?.header ? false : true}
                color="warning"
                startIcon={<CloudDownload />}
                onClick={() => { handleReportDownload(false) }}
              >
                Download
              </Button>
              <Button
                size="small"
                sx={{ width: "100px", marginLeft: 2 }}
                variant="contained"
                // disabled={projectDetails?.header ? false : true}
                color="primary"
                startIcon={<Print />}
                onClick={() => { handleReportDownload(true) }}
              >
                Print
              </Button>
            </Box>
          </Grid>

        </Grid>}
        {originalTableData?.length > 0 && <Grid container spacing={3}>
          <Grid item sm={3} xs={12}>
            <TextField
              fullWidth
              label="From Date"
              size="small"
              type="date"
              value={state?.from_date ?? ''}
              InputLabelProps={{ shrink: true, }}
              variant="outlined"
              name="from_date"
              id="from_date"
              inputProps={{ max: moment().format("YYYY-MM-DD") }}
              onChange={(e) => { setState({ ...state, from_date: e.target.value }) }}

            />
          </Grid>
          <Grid item sm={3} xs={12}>
            <TextField
              fullWidth
              label="To Date"
              size="small"
              type="date"
              value={state?.to_date ?? ''}
              InputLabelProps={{ shrink: true, }}
              variant="outlined"
              name="to_date"
              id="to_date"
              inputProps={{ max: moment().format("YYYY-MM-DD") }}
              onChange={(e) => { setState({ ...state, to_date: e.target.value }) }}

            />
          </Grid>
          <Grid item sm={5} xs={12}>
            <Button
              size="small"
              sx={{ width: "100px", marginLeft: 2 }}
              variant="contained"
              color="primary"
              // startIcon={<Sync />}
              disabled={state?.from_date && state?.to_date ? false : true}
              onClick={() => { handleFilter() }}
            >
              Apply
            </Button>
            <Button
              size="small"
              sx={{ width: "100px", marginLeft: 2 }}
              variant="contained"
              color="primary"
              startIcon={<Sync />}
              disabled={state?.from_date || state?.to_date ? false : true}
              onClick={() => { handleRefresh() }}
            >
              Refresh
            </Button>
          </Grid>
        </Grid>}
        {filteredTableData && filteredTableData?.length > 0 && <Card sx={{ padding: 3 }}>

          <div style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
            <div id="header" style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px", paddingLeft: "100px", paddingRight: "100px" }}>
              <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", alignItems: "center" }}>
                {checkValidation(projectDetails?.header) && 
                  <img id="headerLogo" src={`${ServiceUrl?.showImageUrl}${projectDetails?.header}`} style={{ height: "150px", width: "auto" }} alt="img" />
                  }
              </div>

              <Grid container >
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Project ID: </b>{projectDetails?.project_id}</FormLabel>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Project Name: </b>{projectDetails?.project_name}</FormLabel>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Client: </b>{projectDetails?.company}</FormLabel>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Contract No. : </b>{projectDetails?.contractNo}</FormLabel>
                </Grid>


              </Grid>
            </div>

            <div id="originalTableData">
              <TableContainer component={Paper}>
                <Table>
                  <TableHead style={{ backgroundColor: '#87CEEB' }}>
                    <TableRow>
                      <TableCell>GR. Date</TableCell>
                      <TableCell>Good Receipt No</TableCell>
                      <TableCell>Challan No.</TableCell>
                      <TableCell>Item Code</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Unit</TableCell>
                      <TableCell align='right'>Rate (Nu)</TableCell>
                      <TableCell align='right'>Amount (Nu)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      filteredTableData?.map((row, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell>{moment(row?.good_receipt_date).format("DD/MM/YYYY")}</TableCell>
                            <TableCell>{row?.receipt_no}</TableCell>
                            <TableCell>{row?.challan_no}</TableCell>
                            <TableCell>{row?.item_code}</TableCell>
                            <TableCell>{row?.item_description}</TableCell>
                            <TableCell align="right">{currencyFormat(row?.original_quantity)}</TableCell>
                            <TableCell>{row?.unit_name}</TableCell>
                            <TableCell align="right">{formatNumberWithCommasAndDecimals(row?.rate)}</TableCell>
                            <TableCell align="right">{formatNumberWithCommasAndDecimals(row?.amount)}</TableCell>
                          </TableRow>
                        )
                      })}
                    <TableRow >

                      <TableCell colSpan={8} align="right"><b>Total Amount (Nu)</b></TableCell>
                      <TableCell align="right"><b>{formatNumberWithCommasAndDecimals(totalAmount)}</b></TableCell>
                    </TableRow>

                  </TableBody>
                </Table>
              </TableContainer>

            </div>
          </div>
        </Card>}

      </div>
      {loading && (
        <Loader
          show={loading}
        />
      )}
      {(isPrinting || isDownloading) && (
        <Loader
          show={isPrinting ? isPrinting : isDownloading}
          text="Processing...Please wait."
        />
      )}

    </>
  )
}